import React from "react";
import {
  StyledSectionContainer,
  StyledSectionWrapper,
  StyledAboutUs,
  StyledHeaderWrapper,
} from "./styles/AboutStyles";
import { StyledHeader } from "./styles/CommonStyles";

const About = () => {
  return (
    <StyledSectionWrapper>
      <StyledSectionContainer id="o-nas">
        <StyledHeaderWrapper>
          <StyledHeader>Nasza firma</StyledHeader>
        </StyledHeaderWrapper>
        <StyledAboutUs>
          Odpowiadając na rosnące potrzeby rynku energetycznego powstała nasza Grupa Kapitałowa EPB,
          składająca się z doświadczonej i wykwalifikowanej kadry inżynierów oraz elektromonterów z branży elektroenergetycznej.
          Oferujemy kompleksową realizację inwestycji w zakresie działalności
          projektowej oraz wykonawstwa i nadzorów. Działamy w sposób elastyczny,
          przeanalizujemy Państwa potrzeby i przedstawimy optymalne, najlepsze
          rozwiązania.
        </StyledAboutUs>
      </StyledSectionContainer>
    </StyledSectionWrapper>
  );
};

export default About;
